module.exports = __webpack_public_path__ + "0091b59d07e4482e56f331d1564e2a03.ttf";


//////////////////
// WEBPACK FOOTER
// ./assets/Lato-Heavy.ttf
// module id = 972
// module chunks = 0